export const namespace = 'machines';

export const MutationTypes = {
  SET_MACHINES: 'SET_MACHINES',
};

export const ActionTypes = {
  GET_MACHINES: 'GET_MACHINES',
};
